import React from 'react';

// The real homepage is server-rendered by functions/index.js (product cards
// from the Makers API, carousel copy in lib/home/data.js), and every link to
// `/` is a plain <a>, so this route only renders if that function is down.
// Keep it a plain list of ways in rather than a second copy of the page.
const Home: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 py-20 text-center">
    <h1 className="text-3xl font-bold text-gray-900 mb-4">Woodlogos</h1>
    <p className="text-gray-600 mb-8">A home for makers, and the things we make.</p>
    <div className="flex flex-wrap justify-center gap-4">
      <a href="/makers/apps" className="btn-primary">Browse apps</a>
      <a href="/isee/" className="text-blue-600 font-medium">ISEE Prep</a>
      <a href="/sat/" className="text-blue-600 font-medium">SAT Prep</a>
      <a href="/books" className="text-blue-600 font-medium">Publishing</a>
    </div>
  </div>
);

export default Home;
